export const SIGN_IN_DESTINATION_FALLBACK = '/?fromAuth';

// Only root-relative app paths are valid. The same rule runs when generating
// links and at navigation time, since emailed query strings can be edited.
export function safeSignInDestination(value) {
  if (typeof value !== 'string') return SIGN_IN_DESTINATION_FALLBACK;
  let decoded = value;
  for (let i = 0; i < 10; i++) {
    if (!decoded.startsWith('/') || decoded.startsWith('//') || /[\\\u0000-\u001f\u007f]/.test(decoded)) {
      return SIGN_IN_DESTINATION_FALLBACK;
    }
    try {
      // A dummy base lets the browser and server parse relative paths alike.
      // No request is made to this origin; checking it below rejects external
      // destinations, while successful validation returns the original path.
      const url = new URL(decoded, 'https://signin.invalid');
      if (url.origin !== 'https://signin.invalid') return SIGN_IN_DESTINATION_FALLBACK;
      const next = decodeURIComponent(decoded);
      if (next === decoded) return value;
      decoded = next;
    } catch (_) {
      return SIGN_IN_DESTINATION_FALLBACK;
    }
  }
  return SIGN_IN_DESTINATION_FALLBACK;
}
